import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { UtilityService } from "../shared/services/Utility.service";
import * as $ from 'jquery';
import { Subscription, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { HotkeysService, Hotkey } from 'angular2-hotkeys';
import { UserSettings } from './usersettings';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CommonReportService } from '../shared/services/CommonReportService.service'
var moment = require('moment');
import Swal from 'sweetalert2';

@Component({
    selector: 'commonreport-template',
    template: require('./CommonReportTemplate.html'),
    styles: [`
    .form-control{
        height: calc(1.5em + 0.50rem);;
        padding: 0px;
        text-transform: inherit !important;
        font-size: 14px;
    }

    .form-control.CustomControl{
        font-size: 12px;
    }

    .ButtonInList{
        border: 0;
        background-color: inherit;
    }

    hr{
        margin-top: .5rem;
        margin-bottom: .5rem;
    }
    `]
})
export class CommonReportComponent implements OnInit {
    @Input('Report_Name') ReportName: any;
    @Input('Report_Param_Data') ReportParamListData: any;
    @Input("dValue") dvalue: any;
    @ViewChild('ParamListpopup') ParamListpopup: NgbModalRef;
    modalReference: NgbModalRef;
    public rowSelection: any;
    busy: Subscription;
    public bsConfig: any;
    public RowData: any;
    public SelectedParamName = '';
    public SelectedReportId = 0
    public SelectedReportName = '';
    public SelectedReportCaption = '';
    public ParamTableData: any;
    public ListGridcolumnDefs: any;
    public ReportParamData: any;
    public gridApi: any;
    public gridColumnApi: any;
    public SelectedParamData: any;
    public unitInfo: any;
    public SelectedListName = '';
    public ParamListData: any;
    public Serach_Text_Box: any;
    public CurrentSelectedParam: any;
    public TreeViewSearchBox = '';
    public ReportAllTreeList: any;
    public ReportFavTreeList: any;
    public ReportRecentTreeList: any;
    public CurrentSelectedReportType = '';
    public PrintTypeList: any;
    public PrintType: any;
    public FormatType: any;
    public FormatTypeList: any;
    public ColumnList: any;
    public hotkeyList: Hotkey[];
    public hotkeyListModal: Hotkey[];
    public IsPopUpOpen = 0;
    public ProgressBar: any;
    public ProgressValue: any;
    RegisterId: any;
    toast = Swal.mixin({
        toast: true,
        position: 'center',
        showConfirmButton: false,
        timer: 3000
    });

    static parameters = [HttpClient, UtilityService, Router, NgbModal, HotkeysService, CommonReportService];
    constructor(private http: HttpClient, public utilityService: UtilityService, private router: Router, private modalService: NgbModal, private hotkeysService: HotkeysService, public commonReportService: CommonReportService) {
        this.http = http;
        this.router = router;
        this.modalService = modalService;
        this.hotkeysService = hotkeysService;
        //config.backdrop = 'static';
    }
    paginationConf: any;
    d: any;
    private defaultColDef;
    ngOnInit(): void {
        this.defaultColDef = {
            resizable: true,
        };
        this.ProgressBar = 'determinate';
        this.ProgressValue = 0;
        //   console.log('Common Report template init!');
        this.paginationConf = UserSettings.enablePagination;
        this.unitInfo = JSON.parse(localStorage.getItem('permission'))[0];
        this.bsConfig = Object.assign({}, { dateInputFormat: this.unitInfo.dateInputFormat, containerClass: this.unitInfo.dateColorTheme });
        this.d = this.dvalue;
        this.PrintTypeList = [
            { id: 'preview', name: 'Preview' },
            { id: 'print', name: 'Print' }
        ];
        this.FormatTypeList = [
            { id: 'pdf', name: 'PDF' },
            { id: 'xls', name: 'Excel' },
            { id: 'csv', name: 'CSV' },
            { id: 'docx', name: 'DOCX' }
        ];
        this.FormatType = 'pdf';
        this.PrintType = 'preview';
        this.RowData = [];
        this.CurrentSelectedParam = {};
        this.ParamListData = {};
        this.SelectedReportCaption = '';
        this.SelectedReportName = '';
        //   console.log("this.CommonReport.unitInfo", this.unitInfo);

        this.SelectedParamData = [];
        this.ParamTableData = [];
        this.initHotKey();
        this.ColumnList = [
            { headerName: 'id', field: 'id', hide: true, ListName: '' }
            , { headerName: '', field: 'selected', hide: false, ListName: '' }
            , { headerName: 'Code', field: 'code', hide: false, ListName: 'product', width: 60 }
            , { headerName: 'Code', field: 'code', hide: false, ListName: 'customer', width: 60 }
            , { headerName: 'Code', field: 'code', hide: false, ListName: 'vendor', width: 60 }
            , { headerName: 'Code', field: 'code', hide: false, ListName: 'bank', width: 60 }
            , { headerName: 'Name', field: 'name', hide: false, ListName: '' }
            , { headerName: 'Packsize', field: 'packsize', hide: false, ListName: 'product', width: 100 }
            , { headerName: 'Manufacturer', field: 'manufacturer', hide: false, ListName: 'product', width: 100 }
            , { headerName: 'Area', field: 'area', hide: false, ListName: 'customer', width: 100 }
            , { headerName: 'City', field: 'city', hide: false, ListName: 'customer', width: 100 }
            , { headerName: 'City', field: 'city', hide: false, ListName: 'vendor', width: 100 }
            , { headerName: 'Ledger Account', field: 'RecoGroup', hide: false, ListName: 'vendor', width: 100 }
        ];

        this.RowData = [];
        this.CurrentSelectedParam = {};
        this.ParamListData = {};
        this.SelectedParamData = [];
        this.ParamTableData = [];
        var parent = this;
        let Info = { ReportId: 0, ReportName: this.ReportName };
        this.http.post('/api/CommonReports/SP_GET_REPORT_PARAM_DETAILS_BYID', [Info])
            .subscribe(result => {
                //   console.log(result);
                let data: any;
                data = result;
                this.ParamTableData = [];
                for (var i = 0; i < Object.keys(data[0]).length; i++) {
                    this.SelectedReportId = data[0][i]["ReportId"];
                    this.SelectedReportCaption = data[0][i]["ReportCaption"];
                    this.SelectedReportName = data[0][i]["ReportName"];
                    this.RegisterId = Number(data[0][i]["RegisterId"]);                    
                }

                for (var i = 0; i < Object.keys(data[1]).length; i++) {
                    this.ParamTableData.push(data[1][i]);
                }
                var FocusId = '';
                for (var i = 0; i < this.ParamTableData.length; i++) {
                    this.ParamTableData[i].ParamValue = this.ReportParamListData[this.ParamTableData[i].ParamId];
                    if (this.ParamTableData[i].ParamValue && this.ParamTableData[i].ParamType == "date") {
                        this.ParamTableData[i].ParamValue = moment(new Date(this.ParamTableData[i].ParamValue)).format(this.unitInfo.dateInputFormat);
                    }
                }
                if (this.ParamTableData.length > 0) {
                    FocusId = this.ParamTableData[0]["ParamId"];
                }
                let list = [];
                list = [];
                list = this.ParamTableData.filter(function (item) { return item.ParamType == 'dropdown' });
                for (var i = 0; i < list.length; i++) {
                    this.ParamListData[list[i].ParamId] = [];
                    if (data.length <= (i + 3))
                        break;
                    for (var j = 0; j < Object.keys(data[i + 2]).length; j++) {
                        this.ParamListData[list[i].ParamId].push(data[i + 2][j]);
                    }
                    if (this.ParamListData[list[i].ParamId].length > 0) {
                        var ind = this.ParamTableData.map(item => item.ParamId).indexOf(list[i].ParamId);
                        this.ParamTableData[ind].ParamValue = this.ParamListData[list[i].ParamId][0].id;
                    }
                }
                setTimeout(() => {
                    $('#' + FocusId).focus();
                }, 100);
            });
    }

    initHotKey() {
        this.hotkeyList = [];
        this.hotkeyListModal = [];

        const ctrl = new Hotkey('ctrl+enter', (event: KeyboardEvent): boolean => {
            this.OnParamDataEnter(this.ParamListpopup, event);
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(ctrl);
        this.hotkeysService.add(ctrl);

        const enter = new Hotkey('enter', (event: KeyboardEvent): boolean => {
            if (this.IsPopUpOpen)
                return;
            var self = $(this), focusable, next;
            //   console.log('event');
            //   console.log(event);
            if (event.keyCode == 13) {
                focusable = $('.modal-body').find('input:enabled, ng-select, a, select, textarea, input[role=combobox]:enabled').filter(':visible');
                next = focusable.eq(focusable.index(event.target) + 1);
                setTimeout(() => {
                    if (next[0].id) {
                        if ($(next[0]).prop("tagName") == 'NG-SELECT') {
                            var focusId = $(next[0]).attr('id');
                            var focusIdElem = '#' + focusId + ' input[role=combobox]';
                            $(focusIdElem).focus();
                        } else {
                            $(next[0]).focus();
                        }
                        var ListType = this.ParamTableData.filter(function (item) {
                            return item.ParamId == next[0].id
                        });
                        if (ListType.length > 0) {
                            this.CurrentSelectedParam = ListType[0];
                            this.OnParamRowClick(this.CurrentSelectedParam);
                        }
                    }
                }, 100);
            }
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(enter);
        this.hotkeysService.add(enter);

        const esc = new Hotkey('esc', (event: KeyboardEvent): boolean => {
            if (this.IsPopUpOpen) {
                this.OnParamRowClick(this.CurrentSelectedParam);
            }
            this.IsPopUpOpen = 0;
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(esc);
        this.hotkeysService.add(esc);

    }

    toastWarningMsg(options) {
        this.toast({
            type: 'warning',
            title: options,
            timer: 3000
        });
    }

    ngOnDestroy() {
        this.hotkeysService.remove(this.hotkeyList);
        this.modalService.dismissAll();
    }

    ngAfterViewInit() {
        this.paginationConf = UserSettings.enablePagination;
    }

    OnParamRowClick(Param) {
        this.SelectedParamName = Param.ParamName;
        this.CurrentSelectedParam = Param;
        this.SelectedParamData = [];
        if (Param.ParamType == 'date') {
            this.SelectedParamData = [
                { id: Param.ParamValue, name: Param.ParamValue, ParamType: Param.ParamType }
            ]
        } else if (Param.ParamType == 'checkbox') {
            this.SelectedParamData = [
                { id: Param.ParamValue, name: (Param.ParamValue ? 'Y' : 'N'), ParamType: Param.ParamType }
            ]
        } else if (Param.ParamType == 'dropdown') {
            if (Param.ParamValue) {
                //var text = document.getElementById(Param.ParamId).innerText;
                let text: any = (document.getElementById(Param.ParamId).getElementsByClassName("ng-has-value").length > 0 ? document.getElementById(Param.ParamId).getElementsByClassName("ng-value-label")[0] : '');
                //var text = $('#' + Param.ParamId + ' .ng-has-value')? $('#' + Param.ParamId + ' .ng-value-label').textContent : '';
                this.SelectedParamData = [
                    { id: Param.ParamValue, name: text.innerText ? text.innerText : '', ParamType: Param.ParamType }
                ]
            }
        } else if (Param.ParamType == 'text' || Param.ParamType == 'integer' || Param.ParamType == 'decimal') {
            if (Param.ParamValue) {
                this.SelectedParamData = [
                    { id: Param.ParamValue, name: Param.ParamValue, ParamType: Param.ParamType }
                ]
            }
        } else {
            if (this.ParamListData[Param.ParamId]) {
                this.SelectedParamData = this.ParamListData[Param.ParamId].filter(function (item) { return item.selected == 1 });
                if (this.SelectedParamData.length > 0) {
                    var targetIdx = this.ParamTableData.map(item => item.ParamId).indexOf(Param.ParamId);
                    if (this.ParamTableData[targetIdx].ParamListValue == '') {
                        var name = Array.prototype.map.call(this.SelectedParamData, function (item) { return item.name; }).join(",");
                        var id = Array.prototype.map.call(this.SelectedParamData, function (item) { return item.id; }).join(",");
                        this.ParamTableData[targetIdx].ParamValue = id;
                        this.ParamTableData[targetIdx].ParamListValue = name;
                    }
                }
            }
        }
    }

    OpenReportPreview(FormatType, PrintType) {
        this.ReportParamData = {};
        //alert('preview');
        // if(!this.PrintType){
        //     alert('Please Select Print Method');
        //     $('#PrintType').focus();
        //     return;
        // }

        // if(!this.FormatType){
        //     alert('Please Select Report Method');
        //     $('#FormatType').focus();
        //     return;
        // }

        if (!this.SelectedReportName) {
            //alert('Please Select Report From Left Panel');
            this.toastWarningMsg("Please Select Report From Left Panel");
            return;
        }
        var a = this.ParamTableData.filter(function (item) {
            return item.IsRequired == 1 && (item.ParamValue == null || item.ParamValue == '')
        });
        //   console.log(a);
        if (a && a.length > 0) {
            this.toastWarningMsg(a[0].ParamName + ' Can not be blank');
            if (a[0].ParamType == 'dropdown') {
                var focusId = a[0].ParamId;
                var focusIdElem = '#' + focusId + ' input[role=combobox]';
                $(focusIdElem).focus();
            } else {
                $('#' + a[0].ParamId).focus();
            }
            //alert(a[0].ParamName +' Can not be blank');
            return;
        }
        for (var i = 0; i < this.ParamTableData.length; i++) {
            if (this.ParamTableData[i].ParamType == 'date') {
                this.ReportParamData[this.ParamTableData[i].ParamId] = moment(this.ParamTableData[i].ParamValue).format('YYYY-MM-DD');
            } else {
                this.ReportParamData[this.ParamTableData[i].ParamId] = this.ParamTableData[i].ParamValue ? this.ParamTableData[i].ParamValue : '';
            }
        }
        //   console.log(this.ReportParamData);
        // if(this.PrintType == ''){
        //     alert('Please Select Print Method');
        //     return;
        // }
        this.OpenJasperReport(this.SelectedReportName, FormatType, PrintType);
    }

    OnSelectedValueDeleteClick(item, IsDeleteAll) {
        var name = '';
        var id = '';

        if (IsDeleteAll == 1) {
            for (var i = 0; i < this.SelectedParamData.length; i++) {
                var targetIdx = this.ParamListData[this.CurrentSelectedParam.ParamId].map(item => item.id).indexOf(this.SelectedParamData[i].id);
                this.ParamListData[this.CurrentSelectedParam.ParamId][targetIdx].selected = 0;
            }
            this.SelectedParamData = [];
        } else {
            var targetIdx = this.ParamListData[this.CurrentSelectedParam.ParamId].map(item => item.id).indexOf(item.id);
            this.ParamListData[this.CurrentSelectedParam.ParamId][targetIdx].selected = 0;
            var targetIdx = this.SelectedParamData.map(item => item.id).indexOf(item.id);
            if (targetIdx >= 0) {
                this.SelectedParamData.splice(targetIdx, 1);
            }

            name = Array.prototype.map.call(this.SelectedParamData, function (item) { return item.name; }).join(",");
            id = Array.prototype.map.call(this.SelectedParamData, function (item) { return item.id; }).join(",");
        }
        var targetIdx = this.ParamTableData.map(item => item.ParamId).indexOf(this.CurrentSelectedParam.ParamId);
        this.ParamTableData[targetIdx].ParamValue = id;
        this.ParamTableData[targetIdx].ParamListValue = name;
        //alert(a);
    }

    closePopup() {
        this.OnPopupOkClick();
        this.IsPopUpOpen = 0;
    }

    OnPopupOkClick() {
        this.SelectedParamData = this.gridApi.getSelectedRows();
        //   console.log(' this.SelectedParamData : ', this.SelectedParamData);
        let SelectedID = this.SelectedParamData.map(function (el) { return el.id; });
        let name = this.SelectedParamData.map(function (el) { return el.name; }).toString();
        var targetIdx = this.ParamTableData.map(item => item.ParamId).indexOf(this.CurrentSelectedParam.ParamId);
        this.ParamTableData[targetIdx].ParamValue = (SelectedID.toString());
        this.ParamTableData[targetIdx].ParamListValue = name;
        this.ParamListData[this.CurrentSelectedParam.ParamId].map(result => {
            if (SelectedID.includes(result.id)) {
                result.selected = 1;
            } else {
                result.selected = 0;
            }
        });
        // if(this.ParamListData[this.CurrentSelectedParam.ParamId]){  
        //     this.SelectedParamData = this.ParamListData[this.CurrentSelectedParam.ParamId].filter(function(item){ return item.selected == 1});

        //     var name = Array.prototype.map.call(this.SelectedParamData, function(item) { return item.name; }).join(",");
        //     var id = Array.prototype.map.call(this.SelectedParamData, function(item) { return item.id; }).join(",");
        //     var targetIdx = this.ParamTableData.map(item => item.ParamId).indexOf(this.CurrentSelectedParam.ParamId); 
        //     this.ParamTableData[targetIdx].ParamValue = id;
        //     this.ParamTableData[targetIdx].ParamListValue = name;       
        // }
        this.modalReference.close();
    }

    // OnParamDataEnter(ParamListpopup, event){
    //     if(!event.target.classList.contains('ListParamClass')){
    //         return;
    //     }
    //     this.Serach_Text_Box = '';
    //     this.RowData = [];
    //     this.SelectedListName = event.target.name;
    //     var ParamId = event.target.id;

    //     var ListType = this.ParamTableData.filter(function(item){
    //         return item.ParamId == ParamId
    //     });

    //     // if (this.modalService.hasOpenModals()) {
    //     //     this.modalService.dismissAll('close all to open new popup!');
    //     // }  
    //     this.CurrentSelectedParam =  ListType[0];     
    //     var list = [];
    //     list = this.ColumnList.filter(function(item){return item.ListName == '' || item.ListName == ListType[0].ListName.toLowerCase()})
    //     if(list.length > 3) {
    //         //if(ListType[0].ListName.toLowerCase() == 'product' || ListType[0].ListName.toLowerCase() == 'customer' || ListType[0].ListName.toLowerCase() == 'vendor'){
    //         this.IsPopUpOpen = 1;
    //         this.modalReference = this.modalService.open(ParamListpopup, { size: 'sm', windowClass: 'data-show ParamListMediumSize' });
    //     } else {
    //         this.modalReference = this.modalService.open(ParamListpopup, { size: 'sm', windowClass: 'data-show ParamListSmallSize' });
    //         this.IsPopUpOpen = 1;
    //     }
    //     this.rowSelection = ListType[0].SelectionType? ListType[0].SelectionType: 'multiple';
    //     var Parent = this;
    //     this.ListGridcolumnDefs = [];
    //     for(var i = 0; i < list.length; i++){
    //         if(list[i].field == 'selected'){
    //             this.ListGridcolumnDefs.push(
    //             { headerName: list[i].headerName, field: list[i].field,width : (list.length > 3 ? 100 : 20)            
    //                 ,cellRenderer: function(params) { 
    //                     var input = document.createElement('input');                        
    //                     if(Parent.rowSelection == "single"){
    //                         input.type = "radio";
    //                         input.id = 'Check_' + params.node.data.id;
    //                         input.name = 'Check_';
    //                     } else {
    //                         input.type = "checkbox";
    //                         input.id = 'Check_' + params.node.data.id;
    //                         input.name = 'Check_' + params.node.data.id;
    //                     }
    //                     input.style.height = "25px";
    //                     input.style.width = "18px";
    //                     input.style.marginLeft = "18px";
    //                     input.checked = params.value;
    //                     return input;
    //                 }
    //             });
    //         } else {
    //             if(list[i].width){
    //                 this.ListGridcolumnDefs.push({headerName: list[i].headerName, field: list[i].field ,hide :list[i].hide });
    //             } else {
    //                 this.ListGridcolumnDefs.push({headerName: list[i].headerName, field: list[i].field ,hide :list[i].hide ,width :list[i].width });
    //             }
    //         }
    //     }

    //   //   console.log('this.ParamListData');
    //   //   console.log(this.ParamListData);
    //     if(!this.ParamListData[ParamId] && ListType[0].ListName!=''){
    //         let Info = { "List_Name": ListType[0].ListName, "Unit_ID": this.unitInfo.Unit_ID, "Company_Id": this.unitInfo.Company_ID };
    //       //   console.log('Info');
    //       //   console.log(Info);
    //         this.http.post('/api/CommonReports/SP_GET_PARAM_DETAILS_LIST', [Info])
    //         .subscribe(result => {
    //             this.ParamListData[ParamId] = result;
    //             this.RowData = result;   
    //             setTimeout(() => {
    //                 if(this.RowData.length > 0) {
    //                     var Index = 0;
    //                     // this.gridApi.setFocusedCell(Index, "selected");  
    //                     // this.gridApi.getModel().getRow(Index).setSelected(true);
    //                 }                
    //             }, 100);
    //             setTimeout(() => {
    //                 let allColumnIds = [];
    //                 this.gridColumnApi.getAllColumns().forEach(function (column) {
    //                     allColumnIds.push(column.colId);
    //                 });
    //                 this.gridColumnApi.autoSizeColumns(allColumnIds);
    //             }, 200);
    //         });
    //     } else {
    //         this.RowData = this.ParamListData[ParamId];
    //         $(document).ready(function(){
    //             $('.ag-center-cols-viewport').css('overflow','inherit');
    //         });
    //         setTimeout(() => {
    //             if(this.RowData.length > 0) {
    //                 var Index = 0;
    //                 // this.gridApi.setFocusedCell(Index, "selected");
    //                 // this.gridApi.getModel().getRow(Index).setSelected(true);
    //             }                
    //         }, 100);
    //         setTimeout(() => {
    //             let allColumnIds = [];
    //             this.gridColumnApi.getAllColumns().forEach(function (column) {
    //                 allColumnIds.push(column.colId);
    //             });
    //             this.gridColumnApi.autoSizeColumns(allColumnIds);
    //         }, 200);
    //     }
    //     setTimeout(() => {
    //         $(document).ready(function(){
    //             $('.ag-center-cols-viewport').css('overflow','inherit');
    //             $('.ag-body-viewport.ag-layout-normal').css('overflow','overlay');
    //             $('#Serach_Text_Box').focus();
    //         }); 
    //     }, 100);
    // }

    OnParamDataEnter(ParamListpopup, event) {
        if (!event.target.classList.contains('ListParamClass')) {
            return;
        }
        this.Serach_Text_Box = '';
        this.RowData = [];
        this.SelectedListName = event.target.name;
        var ParamId = event.target.id;

        var ListType = this.ParamTableData.filter(function (item) {
            return item.ParamId == ParamId
        });

        if (this.modalService.hasOpenModals()) {
            this.modalService.dismissAll('close all to open new popup!');
        }
        var list = [];
        list = this.ColumnList.filter(function (item) { return item.ListName == '' || item.ListName == ListType[0].ListName.toLowerCase() });

        if (list.length > 3) {
            //if(ListType[0].ListName.toLowerCase() == 'product' || ListType[0].ListName.toLowerCase() == 'customer' || ListType[0].ListName.toLowerCase() == 'vendor'){
            this.modalReference = this.modalService.open(ParamListpopup, { size: 'sm', windowClass: 'data-show ParamListMediumSize' });
        } else {
            this.modalReference = this.modalService.open(ParamListpopup, { size: 'sm', windowClass: 'data-show ParamListSmallSize' });
        }
        this.rowSelection = ListType[0].SelectionType ? ListType[0].SelectionType : 'multiple';
        this.ListGridcolumnDefs = [];
        var Parent = this;
        for (var i = 0; i < list.length; i++) {
            if (list[i].field == 'selected') {
                this.ListGridcolumnDefs.push(
                    {
                        headerName: list[i].headerName, width: (list.length > 3 ? 100 : 20), checkboxSelection: true, headerCheckboxSelection: (Parent.rowSelection == "single" ? false : true)
                    });
            } else {
                if (list[i].width) {
                    this.ListGridcolumnDefs.push({ headerName: list[i].headerName, field: list[i].field, hide: list[i].hide });
                } else {
                    this.ListGridcolumnDefs.push({ headerName: list[i].headerName, field: list[i].field, hide: list[i].hide, width: list[i].width });
                }
            }
        }

        //this.OnParamRowClick(ListType[0]);

        //   console.log('this.ParamListData');
        //   console.log(this.ParamListData);
        if (!this.ParamListData[ParamId] && ListType[0].ListName != '') {
            let Info = { "List_Name": ListType[0].ListName, "Unit_ID": this.unitInfo.Unit_ID, "Company_Id": this.unitInfo.Company_ID };
            //   console.log('Info');
            //   console.log(Info);
            this.busy = this.http.post('/api/CommonReports/SP_GET_PARAM_DETAILS_LIST', [Info])
                .subscribe(result => {
                    this.ParamListData[ParamId] = result;
                    this.RowData = result;
                    setTimeout(() => {
                        let allColumnIds = [];
                        this.gridColumnApi.getAllColumns().forEach(function (column) {
                            allColumnIds.push(column.colId);
                        });
                        if (this.RowData.length > 0) {
                            this.gridApi.setFocusedCell(0, allColumnIds[2].colId);
                            this.gridColumnApi.autoSizeColumns(allColumnIds);
                        }
                        $('#Serach_Text_Box').focus();
                    }, 300);
                });
        } else {
            this.RowData = this.ParamListData[ParamId];
            $(document).ready(function () {
                $('.ag-center-cols-viewport').css('overflow', 'inherit');
            });
            setTimeout(() => {
                let allColumnIds = [];
                this.gridColumnApi.getAllColumns().forEach(function (column) {
                    allColumnIds.push(column.colId);
                });
                if (this.RowData.length > 0) {
                    var Index = 0;
                    var data = this.RowData.filter(function (item) {
                        return item.selected === 1;
                    });
                    data.forEach(element => {
                        Index = this.RowData.indexOf(element);
                        this.gridApi.getModel().getRow(Index).setSelected(true);
                    });
                    this.gridApi.setFocusedCell(0, allColumnIds[2].colId);
                }
                this.gridColumnApi.autoSizeColumns(allColumnIds);
                $('#Serach_Text_Box').focus();
            }, 200);
        }
        setTimeout(() => {
            var parent = this;
            $(document).ready(function () {
                $('.ag-center-cols-viewport').css('overflow', 'inherit');
                $('.ag-body-viewport.ag-layout-normal').css('overflow', 'overlay');
            });
        }, 100);
    }
    OnCellClick(event) {
        var select = 0;
        select = Number(!event.data.selected);
        event.data.selected = select;
        $('#Check_' + event.data.id).prop('checked', select ? true : false);
    }

    onGridReady(params) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;

        setTimeout(() => {
            this.gridApi.sizeColumnsToFit();
        }, 100);
    }

    onSerachTextBoxFilterChanged() {
        let value = $('input#Serach_Text_Box').val();
        this.gridApi.setQuickFilter(value);
    }

    OpenJasperReport(FileName, FormatType, PrintType) {
        this.ProgressBar = 'indeterminate';
        var data = {
            "FileName": FileName, 
            "FormatType": FormatType, 
            "params": this.ReportParamData,
            "RecentReportModel": { 
                "Unit_ID": this.unitInfo.Unit_ID, 
                "Company_Id": this.unitInfo.Company_ID, 
                "User_Id": this.unitInfo._id, 
                "User_Name": this.unitInfo.Full_Name, 
                "Report_Id": this.SelectedReportId, 
                "Report_Name": this.SelectedReportCaption, 
                "Report_Type": FormatType 
            }
        };

        this.busy = this.commonReportService.GetJasperReport(data, this.RegisterId).subscribe(response => {
            var filename = '';
            this.ProgressBar = 'determinate';
            this.ProgressValue = 100;
            if (response) {
                var error = '';
                error = response["error"];
                //   console.log(error);
                filename = response["FilePath"];
                if (filename.length > 0) {
                    if (PrintType == 'print') {
                        $('<iframe>', {
                            name: 'IFramePdfPrint',
                            class: 'printFrame',
                            src: filename,
                            style: 'display:none',
                        }).appendTo('body');
                        window.frames['IFramePdfPrint'].focus();
                        window.frames['IFramePdfPrint'].print();
                    } else if (PrintType == 'preview') {
                        window.open(filename, '_blank');
                    }
                }
            }
            setTimeout(() => {
                this.ProgressValue = 0;
            }, 300);
        });

        //   console.log('this.busy');
        //   console.log(this.busy);
    }

    OnPrintMethodChange() {
        if (this.PrintType == 'print') {
            this.FormatType = 'pdf';
        }
    }

    close() {
        this.modalService.dismissAll();
    }
}